
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Estimate } from "@/types";
import { toast } from "@/hooks/use-toast";

export const useEstimateNotes = (estimateId?: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const buildMutation = (field: 'notes' | 'internal_notes') =>
    useMutation({
      mutationFn: async (newText: string) => {
        if (!estimateId) throw new Error("Estimate ID non fornito");
        const { error } = await supabase
          .from("estimates")
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .update({ [field]: newText, updated_at: new Date().toISOString() } as any)
          .eq("id", estimateId)
          .single();
        if (error) throw error;
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["estimate"] });
        toast({ title: "Note aggiornate!" });
        if (onSuccess) onSuccess();
      },
      onError: () => {
        toast({ title: "Errore nel salvataggio note", variant: "destructive" });
      },
    });

  const notesMutation = buildMutation('notes');
  const internalMutation = buildMutation('internal_notes');

  return {
    saveNotes: notesMutation.mutateAsync,
    isSaving: notesMutation.isPending,
    saveInternalNotes: internalMutation.mutateAsync,
    isSavingInternal: internalMutation.isPending,
  };
};
